import { useContext } from "react";
import { ComponentProjectListRequestPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(
    ComponentProjectListRequestPageContext,
  );
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
